export default "__VITE_ASSET__ZTItdVxd__"